import { Component, input } from '@angular/core';
import { LocationState } from '../../store/locations.store';
import { LocationListEntry } from '../location-list-entry/location-list-entry';
import { LocationDescription } from '../location-description/location-description';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-locations-list',
  imports: [LocationListEntry, LocationDescription, Button, NgIcon, RouterLink, TranslocoPipe],
  templateUrl: './locations-list.html',
})
export class LocationsList {
  locations = input.required<LocationState[]>();
  organizationId = input.required<string>();
}
